import { authErrorMessages } from './authErrorCodes';

const defaultValue = { data: {} };

const handleError = (err = defaultValue, setError) => {
  const { errorCode = 99 } = err.data;

  const match = authErrorMessages.find(({ errorCode: code }) => code === errorCode);
  if (match) {
    const { errorMessage, errorField = 'root' } = match;
    setError(errorField, { type: 'manual', message: errorMessage });
  } else {
    setError('root', { type: 'manual', message: 'Unknown error' });
  }
};

export default handleError;
